export class Pessoa {
  pes_cod: number;
  pes_cpf: string;
  pes_nom: string;
  pes_sobrenome: string;
  pes_nome_completo: string;
  pes_mail: string;
  pes_senha: string;
  pes_senha_confirmation: string;
  pes_pass_num: string;
  pes_dat_nas: string;
  pes_rg: string;
  pes_rg_org_exp: string;
  pes_rg_uf: string;
  pes_end_cep: string;
  pes_end_rua: string;
  pes_end_num: string;
  pes_end_bai: string;
  pes_end_cpl: string;
  pes_end_cid: string;
  pes_end_uf: string;
  pes_sexo: string;
  pes_tel_res: string;
  pes_tel_cel: string;
  pes_cod_comp: number;
  cid_cod_end: number;
  uf_cod: number;
  pais_cod: number;
  PrcCdtCod: number;
  uf_cod_rg: number;
  pes_rne: string;
  pes_pass_dat_exp: string;
  pes_pass_dat_val: string;
  pais_cod_pass: number;
  pes_visto_tipo: string;
  pes_visto_dat_val: string;

  constructor() {}

  static fromJson(data) {
    const pessoa = Object.assign(new Pessoa(), data);

    return pessoa;
  }
}



// WEBPACK FOOTER //
// ./src/app/_shared/pessoa/pessoa.ts